import { useBrokersServiceBrokersTeamsAvailablePermissionsList } from '@insurance/api/queries'
import { Divider, Flex, Switch, Typography } from 'antd'

type Props = {
  value?: string[]
  onChange?: (value?: string[]) => void
  broker: number
}

export const TeamPermissionsSwitch = ({
  value = [],
  broker,
  onChange
}: Props) => {
  const { data } = useBrokersServiceBrokersTeamsAvailablePermissionsList({
    broker
  })

  const onChangeSwitch = (checked: boolean, permission: string) => {
    onChange?.(
      checked
        ? [...value, permission]
        : value.filter((record) => record !== permission)
    )
  }

  return (
    <Flex vertical gap={16}>
      {data?.map(({ label, permission }) => (
        <Flex vertical gap={16} key={permission}>
          <Flex gap={8} justify="space-between">
            <Typography>{label}</Typography>
            <Switch
              checked={value?.includes(permission)}
              onChange={(checked) => onChangeSwitch(checked, permission)}
            />
          </Flex>

          <Divider className="m-0" />
        </Flex>
      ))}
    </Flex>
  )
}
